/**
 * La misma regla que `normalizarPropiedad` del servidor, para avisar mientras se
 * escribe. El servidor decide al guardar; esto solo evita mandar algo que va a
 * rebotar — un correo pegado en el campo, en concreto.
 *
 * Copia y no import porque el módulo del servidor abre la base al importarse.
 * Si cambia una, cambia la otra: la prueba del servidor es la que manda.
 */
export type MotivoPropiedadInvalida = 'vacia' | 'es-un-correo' | 'no-es-dominio' | 'esquema-no-http';

const HOST = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/i;

export function normalizarPropiedadCliente(entrada: string): { ok: true } | { ok: false; motivo: MotivoPropiedadInvalida } {
  const s = entrada.trim();
  if (s === '') return { ok: false, motivo: 'vacia' };
  if (s.includes('@')) return { ok: false, motivo: 'es-un-correo' };
  const dominio = /^sc-domain:(.+)$/i.exec(s);
  if (dominio) return HOST.test(dominio[1]!.trim().replace(/\/+$/, '')) ? { ok: true } : { ok: false, motivo: 'no-es-dominio' };
  const esquema = /^([a-z][a-z0-9+.-]*):/i.exec(s)?.[1]?.toLowerCase();
  if (esquema && esquema !== 'http' && esquema !== 'https') return { ok: false, motivo: 'esquema-no-http' };
  if (esquema) {
    try { return HOST.test(new URL(s).hostname) ? { ok: true } : { ok: false, motivo: 'no-es-dominio' }; }
    catch { return { ok: false, motivo: 'no-es-dominio' }; }
  }
  return HOST.test(s.toLowerCase().replace(/^www\./, '').replace(/\/.*$/, '')) ? { ok: true } : { ok: false, motivo: 'no-es-dominio' };
}
